import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TabsPageComponent} from './tabs.page';

const routes: Routes = [
  {
    path: 'tabs',
    component: TabsPageComponent,
    children: [
      {
        path: 'home',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../tab-home/tab-home.module').then(m => m.TabHomeModule)
          }
        ]
      },
      {
        path: 'booking',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../tab-booking/tab-booking.module').then(m => m.TabBookingPageModule)
          }
        ]
      },
      {
        path: 'user',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../tab-user/tab-user.module').then(m => m.TabUserPageModule)
          }
        ]
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TabsPageRoutingModule {
}
